import styled from "styled-components";
import CheckMark from "../../../../../../assets/checkmark.svg";
import "./brand-card.scss";

const Checkmark = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 1.5rem;
  height: 1.5rem;
  background-image: url(${CheckMark});
  background-size: cover;
`;

export const BrandCard = ({ brand, selected, onSelect }) => {
  return (
    <button
      className={`brand-card ${selected ? "selected" : ""}`}
      onClick={() => onSelect(brand.id)}
    >
      <img className="brand-image" src={brand.image} alt={brand.title} />
      <Checkmark className="icon-selected" />
      <div className="brand-details">
        <span className="font-body-bold">{brand.title}</span>
      </div>
    </button>
  );
};
